import React, { useEffect } from 'react';
import './AuthPages.css';

function ReturnToAppPage() {
  useEffect(() => {
    // Define async function inside useEffect
    async function makeApiCall() {
      // Check for login redirect (authToken flow)
      const redirectUrl = localStorage.getItem('redirectUrl');
      const token = localStorage.getItem('authToken');
      const redirectPath = localStorage.getItem('redirectPath');

      if (redirectUrl) {
        // Handle external link redirect if redirectPath exists
        if (redirectPath) {
          localStorage.removeItem('redirectUrl');
          localStorage.removeItem('redirectPath');
          
          // Construct the full URL for the desktop app
          const fullUrl = `http://${redirectUrl}/${redirectPath}`;
          console.log('Redirecting to desktop app:', fullUrl);
          
          try {
            await fetch(fullUrl, {
              method: 'GET',
              mode: 'no-cors'
            });
            console.log('Return to app API called');
          } catch (error) {
            // Silently ignore the expected error
          }
        } 
        // Handle login redirect if token exists
        else if (token) {
          // Clear the stored values
          localStorage.removeItem('redirectUrl');
          localStorage.removeItem('authToken');

          // Make the API call
          try {
            await fetch(`http://${redirectUrl}/login?${token}`, {
              method: 'GET',
              mode: 'no-cors'
            });
            console.log('Return to app API called');
          } catch (error) {
            // Silently ignore the expected error
          }
        }
      }
    }

    // Call the async function immediately
    makeApiCall();
  }, []); // Empty dependency array means this runs once when component mounts

  return (
    <div className="auth-container">
      <div className="auth-logo">
        <img src="/images/dream-book-logo-dark.png" alt="Dreambook Logo" />
      </div>
      
      <div className="auth-welcome">
        <h2>Return to dream book 3D</h2>
        <p className="auth-description">
          Please return to your dream book 3D desktop application to continue.
          The app should automatically sign you in.
        </p>
      </div>
    </div>
  );
}

export default ReturnToAppPage;
